<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('purchase_orders.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openPurchaseOrderForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetPurchaseOrders(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>

                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.status_id"
                                            :placeholder="$t('lang.status_id')"
                                            :items="purchase_order_status"
                                            item-value="option_id"
                                            item-text="option"
                                            prepend-icon="monitor_heart"
                                            :hide-details="true"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="purchase_orders" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openPurchaseOrderForm(props.item)">
                                <td>{{ props.item.purchase_order_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td class="text-center">{{ props.item.order_date }}</td>
                                <td class="text-center">{{ props.item.expected_delivery_date }}</td>
                                <td class="text-center">
                                    <v-chip disabled round text-color="white" class="fs-14 text-center" :color="props.item.status_class">
                                        <span style="min-width: 60px">{{ props.item.status }}</span>
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="purchase_orders"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="purchase_order_dialog">
                <v-card>
                    <v-form ref="form_purchase_order">
                        <v-card-title>
                            <span class="headline">{{
                                purchase_order.purchase_order_id ? $t("lang.edit_purchase_order") : $t("lang.add_purchase_order")
                            }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closePurchaseOrderDialog"
                                :dialog-status="purchase_order_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-focus="purchase_order_dialog"
                                            v-model="purchase_order.purchase_order_id"
                                            :label="$t('lang.purchase_order_id')"
                                            :counter="showCounter(purchase_order.purchase_order_id, 'purchase_orders.purchase_order_id')"
                                            :rules="ifValid('purchase_orders.purchase_order_id')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="purchase_order.rfq_id"
                                            :label="$t('lang.rfq_id')"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('purchase_orders.rfq_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="purchase_order.quote_id"
                                            :label="$t('lang.quote_id')"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('purchase_orders.quote_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="purchase_order.company_id"
                                            :label="`${$t('lang.company_id')} *`"
                                            :items="customers"
                                            item-value="company_id"
                                            item-text="company"
                                            :rules="ifValid('purchase_orders.company_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="purchase_order.billing_address_id"
                                            :label="$t('lang.billing_address_id')"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('purchase_orders.billing_address_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="purchase_order.shipping_address_id"
                                            :label="$t('lang.shipping_address_id')"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('purchase_orders.shipping_address_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="purchase_order.order_date"
                                            :label="$t('lang.order_date')"
                                            :rules="ifValid('purchase_orders.order_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-date-picker
                                            v-model="purchase_order.expected_delivery_date"
                                            :label="$t('lang.expected_delivery_date')"
                                            :rules="ifValid('purchase_orders.expected_delivery_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            v-model="purchase_order.payment_term_id"
                                            :label="$t('lang.payment_term')"
                                            :items="[]"
                                            item-value="value"
                                            item-text="text"
                                            :rules="ifValid('purchase_orders.payment_term_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="purchase_order.subtotal"
                                            :label="$t('lang.subtotal')"
                                            :counter="showCounter(purchase_order.subtotal, 'purchase_orders.subtotal')"
                                            :rules="ifValid('purchase_orders.subtotal')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="purchase_order.discount"
                                            :label="$t('lang.discount')"
                                            :counter="showCounter(purchase_order.discount, 'purchase_orders.discount')"
                                            :rules="ifValid('purchase_orders.discount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="purchase_order.total_amount"
                                            :label="$t('lang.total_amount')"
                                            :counter="showCounter(purchase_order.total_amount, 'purchase_orders.total_amount')"
                                            :rules="ifValid('purchase_orders.total_amount')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="purchase_order.comments"
                                            :label="$t('lang.comments')"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('purchase_orders.comments')"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="purchase_order.purchase_order_id" color="error" @mouseup.left="$refs.delete_purchase_orders.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closePurchaseOrderDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="savePurchaseOrders">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_purchase_orders"
                :heading="$t('lang.delete_purchase_order')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deletePurchaseOrders(purchase_order.purchase_order_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openPurchaseOrderForm" },
                { title: this.$t("lang.refresh"), action: "dbGetPurchaseOrders", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.purchase_order_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.company_id"), sortable: false, width: "50%" },
                { text: this.$t("lang.order_date"), sortable: false, align: "center", width: "15%" },
                { text: this.$t("lang.expected_delivery_date"), sortable: false, align: "center", width: "15%" },
                { text: this.$t("lang.status"), sortable: false, align: "center", width: "10%" },
            ],
            enableAddModal: false,
            enableEditModal: false,
            customers: null,
            purchase_order: {},
            filter: {
                search: "",
                status_id: "",
                company_id: "",
            },
            purchase_order_dialog: false,
            dbGetPurchaseOrders: _.debounce(this.getPurchaseOrders, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchPurchaseOrders", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.purchase_orders) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.refresh();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchPurchaseOrders({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.purchase_orders) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.refresh();
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetPurchaseOrders");
        this.$store.commit("resetOptions");
        next();
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.purchase_orders.purchase_orders_filter,
            page: (state) => state.purchase_orders.page,
            rules_purchase_orders: (state) => state.purchase_orders.rules_purchase_orders,
            purchase_order_status_options: (state) => state.settings.purchase_order_status_options,
            purchase_order_status: (state) => state.options_categories.purchase_order_status,
            purchase_orders: (state) => state.purchase_orders.purchase_orders,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchPurchaseOrders", "savePurchaseOrder", "deletePurchaseOrder", "fetchOptions"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openPurchaseOrderForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_purchase_order) item ? this.$refs.form_purchase_order.resetValidation() : this.$refs.form_purchase_order.reset();

                    this.$nextTick(() => {
                        this.purchase_order = item != null ? this.assignObj2(item, this.rules_purchase_orders) : {};
                        this.purchase_order_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "purchase_order", params: { id: item.purchase_order_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_purchase_order) item ? this.$refs.form_purchase_order.resetValidation() : this.$refs.form_purchase_order.reset();
                    this.purchase_order_dialog = true;
                } else {
                    this.$router.push({ name: "purchase_order" });
                }
            }
        },
        savePurchaseOrders() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_purchase_order")) {
                    let body = this.prepForm(this.purchase_order, this.rules_purchase_orders);

                    this.savePurchaseOrder({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getPurchaseOrders();
                                this.closePurchaseOrderDialog();
                            } else {
                                this.$router.push({ name: "purchase_order", params: { id: data.purchase_order_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deletePurchaseOrders(id = null) {
            this.deletePurchaseOrder({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getPurchaseOrders();
                    this.closePurchaseOrderDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closePurchaseOrderDialog() {
            this.purchase_order_dialog = false;
            this.$refs.delete_purchase_orders.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getPurchaseOrders(pg_refresh = false) {
            this.startLoader();

            this.fetchPurchaseOrders({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.purchase_order_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (this.purchase_order_status == 0 || force == true) await this.fetchOptions({ body: { slug: "purchase_order_status", options: 1 } });

            this.finishLoader();
        },
    },
};
</script>
